import React from "react"
import { SubmitHandler, useForm } from "react-hook-form"
import { InputExternalPriceConfig } from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import { hideEditSidebar } from "lib/store/services/editSidebar/slice"
import { useAppDispatch } from "lib/store"
import alertActions from "lib/store/services/Alert/AlertSlice"

import { CREATE_OR_UPDATE_EXTERNAL_PRICE_CONFIG } from "graphql/mutations/config/CreateOrUpdateExternalPriceConfig"

import EditSidebar from "components/Ui/EditSidebar/EditSidebar"
import EditSidebarHeader from "components/Ui/EditSidebar/EditSidebarHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import ExternalPriceConfigInput from "../../../../components/Config/ExternalPrice/ExternalPriceConfigInput"

type Props = {
  refetch: () => void
}

interface ExtendedInputExternalPriceConfig extends InputExternalPriceConfig {
  id: string
}

export function CreateExternalPriceConfig({ refetch }: Props) {
  const dispatch = useAppDispatch()

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<ExtendedInputExternalPriceConfig>({ mode: "onBlur" })

  const [addExternalPriceConfig, { loading }] = useMutation(CREATE_OR_UPDATE_EXTERNAL_PRICE_CONFIG, {
    onCompleted: () => {
      reset({
        id: "",
        baseUrl: "",
        authUrl: "",
        clientId: "",
        clientSecret: ""
      })
      dispatch(hideEditSidebar())
      dispatch(
        alertActions.actions.createAlert({
          message: "Custom external price provider configuration successfully created",
          type: "success"
        })
      )
      refetch()
    },
    onError: () => {
      dispatch(
        alertActions.actions.createAlert({
          type: "error"
        })
      )
    }
  })

  const onSubmit: SubmitHandler<ExtendedInputExternalPriceConfig> = (data) => {
    addExternalPriceConfig({ variables: { ...data } })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <EditSidebar>
        <EditSidebarHeader title="Create custom external price provider">
          <PrimaryButton type="submit" loading={loading}>
            Save
          </PrimaryButton>
        </EditSidebarHeader>
        <ExternalPriceConfigInput control={control} errors={errors} showId={true}/>
      </EditSidebar>
    </form>
  )
}
